import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const loanProcessorAPI = createApi({
  reducerPath: 'loanProcessor',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getLoanProcessors: builder.query({
      query: ({ pageNumber, pageSize }) => ({
        url: `/b2b/loan/employee/?role=loan_processor&page_number=${pageNumber}&page_size=${pageSize}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      transformResponse: (response) => {
        if (response) {
          return response;
        }
      },
    }),

    /* The same endpoint, with the role as an argument rather than baked into
       the URL. `getLoanProcessors` above is the one-role version that predates
       it and is left alone because several screens call it; anything needing a
       different role uses this. */
    getEmployeesByRole: builder.query({
      query: ({ role, pageNumber = 1, pageSize = 50 }) => ({
        url: `/b2b/loan/employee/?role=${encodeURIComponent(
          role
        )}&page_number=${pageNumber}&page_size=${pageSize}`,
        method: 'GET',
        headers: getHeaders(),
      }),
    }),
  }),
});

export const { useGetLoanProcessorsQuery, useGetEmployeesByRoleQuery } =
  loanProcessorAPI;
